<script setup lang="ts">
const store = usePortfolioStore()

// وضعیت باز/بسته‌ی توضیحات هر مهارت بر اساس ایندکس.
const open = reactive<Record<number, boolean>>({})
const toggle = (index: number) => { open[index] = !open[index] }

const normalizePercent = (value: number | string) =>
  Math.min(100, Math.max(0, Number(value) || 0))

// فقط مهارتی که واقعاً توضیح دارد کلید منوی کشویی می‌گیرد.
const hasDescription = (skill: { description?: unknown }) =>
  typeof skill?.description === 'string' && skill.description.trim().length > 0
</script>

<template>
  <section id="skills" class="px-1 py-8 md:py-12">
    <h2 data-reveal class="text-2xl font-extrabold md:text-3xl"><span class="text-accent">مهارت‌های</span> من</h2>
    <p data-reveal class="mt-3 max-w-2xl text-sm leading-7 text-muted">
      ابزارهایی که هر روز با آن‌ها کار می‌کنم؛ عددها برداشت خودم از میزان تسلط است، نه امتیاز آزمون.
    </p>
    <ul class="mt-8 grid gap-5">
      <li v-for="(s, i) in store.profile?.skills" :key="s.title ?? i" data-reveal>
        <div class="mb-2 flex items-center gap-3 text-sm">
          <!-- <SharedSkillIcon :icon="s.icon" /> -->
          <span class="font-medium">{{ s.title }}</span>
          <span class="ms-auto text-muted">{{ normalizePercent(s.percent) }}٪</span>
          <button
            v-if="hasDescription(s)"
            type="button"
            :aria-expanded="!!open[i]"
            :title="open[i] ? 'بستن توضیحات' : 'نمایش توضیحات'"
            :aria-label="open[i] ? 'بستن توضیحات' : 'نمایش توضیحات'"
            class="grid h-6 w-6 shrink-0 place-content-center rounded-full border border-line text-muted
                   transition duration-300 hover:border-accent hover:text-accent"
            :class="open[i] ? 'border-accent text-accent' : ''"
            @click="toggle(i)"
          >
            <svg
              viewBox="0 0 24 24"
              class="h-4 w-4 transition-transform duration-300"
              :class="open[i] ? 'rotate-180' : ''"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </button>
        </div>
        <div class="h-2 overflow-hidden rounded-full bg-line">
          <div
            :data-bar="normalizePercent(s.percent)"
            class="h-full rounded-full shadow-[0_0_12px_var(--t-accent-soft)]"
            :style="{
              width: `${normalizePercent(s.percent)}%`,
              background: 'linear-gradient(90deg, var(--t-accent), var(--t-accent-2))'
            }"
          ></div>
        </div>
        <Transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="-translate-y-1 opacity-0"
          leave-active-class="transition duration-200 ease-in"
          leave-to-class="-translate-y-1 opacity-0"
        >
          <p
            v-if="hasDescription(s) && open[i]"
            class="mt-3 rounded-xl border border-line bg-surface/60 p-3 text-xs leading-6 text-muted"
          >
            {{ s.description }}
          </p>
        </Transition>
      </li>
    </ul>
  </section>
</template>
